import CityManagementPage from "./shared/CityManagementPage";
import { cityConfigs } from "./shared/cityConfig";

export default function Newcastle() {
  return <CityManagementPage config={cityConfigs.newcastle} />;
}